
import React from 'react'
import { ComponentData } from '../../data/ComponentContext'
import EnergySelect from '../EnergySelect'
import ProcessChart from '../ProcessChart'
import QuantityInput from '../QuantityInput'
import { Col, Row } from 'react-bootstrap'
import Delete from '../../img/delete.svg'
import Arrow from '../../img/arrow-right.svg'


function ProcessTab({ toNextTab, toLastTab }) {

  const { resetProcess, processIsValid, processChartUrl } = ComponentData()

  const saveProcessChart = () => {
    processChartUrl.current = document.getElementById('process-chart').toDataURL()
    // console.log(processChartUrl.current)
  }

  return (
    <div className="process-tab">
      <div className="content-box">
        <h2>Wie ist der aktuelle Prozess?</h2>
        <p>Geben Sie - sofern bekannt - die aktuellen Parameter Ihres Prozesses ein. Nicht bekannte Werte schätzen Sie bitte für die weitere Berechnung.</p>
      </div>
      <div className="configuration-area">
        <Row>
          <Col md={6}>
            <Row>
              <QuantityInput className={'content-box'} />
            </Row>
          </Col>
          <Col md={6}>
            <Row>
              <EnergySelect className={"content-box"} />
            </Row>
          </Col>
        </Row>
      </div>


      <ProcessChart className={'chart-area'} />

      <div className="button-box">
        <button className="delete" onClick={resetProcess}>Zurücksetzen <img className="button-svg" src={Delete} /></button>
        <button onClick={toLastTab}><img className="button-svg back" src={Arrow} alt='' />Zurück</button>
        <button disabled={!processIsValid} onClick={() => {
          // SAVE CHART
          saveProcessChart();
          toNextTab();
        }}>Weiter <img className="button-svg" src={Arrow} /></button>
      </div>

    </div>
  )
}

export default ProcessTab